module.exports = __webpack_public_path__ + "img/mq.2eb10a3e.svg";